import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash";
import {SelfPickupsService} from "../../services/self-pickups-service.service";

export class selfPickupPanelCtrl implements IController {

  selfPickup: any;
  showMap: boolean;
  showTimeline: boolean;
  showActions: boolean;
  onCancel: Function;
  onComplete: Function;
  onClose: Function;

  private selfPickupBindRef: any;
  private loadLimit: number;
  private depotsRef: any;

  private depot: any;
  private timelineInfiniteScroll: any;
  private loading: any;

  /* @ngInject */
  constructor(private $selfPickups, private $depots, private $infiniteScroll, private $scope: IScope,
              private $log, private selfPickupsService: SelfPickupsService) {
  }

  $onInit() {
    this.loadLimit = 30;
    this.depotsRef = this.$depots();

    this.depot = undefined;
    this.timelineInfiniteScroll = undefined;
    this.loading = {
      depot: false,
      timeline: false
    };

    if (this.selfPickup && this.showTimeline) {
      this._setTimeline(this.selfPickup.id);
    }
  };

  $onChanges(changes) {
    if (changes.selfPickup && !changes.selfPickup.isFirstChange()) {
      const currentSelfPickup = changes.selfPickup.currentValue;
      const previousSelfPickup = changes.selfPickup.previousValue;

      if (currentSelfPickup && currentSelfPickup.id !== _.get(previousSelfPickup, 'id')) {
        this.depot = undefined;

        if (this.showMap && currentSelfPickup.depotId) {
          this._setDepot(currentSelfPickup.depotId)
        }

        if (this.showTimeline) {
          this._setTimeline(currentSelfPickup.id);
        }

        this._bindSelfPickup(currentSelfPickup.id);
      }
    }
  };

  // ******************************
  //        Public methods
  // ******************************

  onBeforeClose() {
    this._destroyBindSelfPickup();
    this.onClose();
  }

  // ******************************
  //        Private methods
  // ******************************

  _bindSelfPickup(id) {
    this.selfPickupBindRef = this.$selfPickups(id);
    this.selfPickupBindRef.$bindCtrl(this.$scope, this, 'selfPickup');
  }

  _destroyBindSelfPickup() {
    if (this.selfPickupBindRef) {
      this.selfPickupBindRef.$destroy();
    }
  }

  _setDepot(depotId) {
    this.loading.depot = true;
    this.depotsRef.$asyncValues([depotId])
      .then((depots) => {
        this.depot = depots[0];
      })
      .catch((error) => {
        this.$log.error(error);
      })
      .finally(() => {
        this.loading.depot = false;
      })
  }

  _setTimeline(id) {
    const timelinesRef = this.selfPickupsService.getTimelineLogRef(id, this.loadLimit);
    this.timelineInfiniteScroll = this.$infiniteScroll(timelinesRef, this.loadLimit);
  }

  _getTimelineQueryPayload(id) {
    return {
      limit: this.loadLimit,
      entityName: 'SelfPickup',
      entityId: id
    }
  }

}

angular
  .module('bringoz.admin.self-pickups')
  .component('selfPickupPanel', {
    bindings: {
      selfPickup: '<',
      showMap: '<?',
      showTimeline: '<?',
      showActions: '<?',
      onCancel: '&',
      onComplete: '&',
      onClose: '&'
    },
    template: require('./self-pickup-panel.html').default,
    controller: selfPickupPanelCtrl
  });
